import React from 'react';

import Loader from 'crehana-ui/Loader';

import Loadable from 'Jsx/Shared/Loadable';
import LazyLoad from 'Jsx/Shared/Lazyload';
import useMembershipRenovation from 'Jsx/Shared/Hooks/useMembershipRenovation';

const LazyMembershipRenovationBanner = props => {
  const {
    remainingDays,
    showRenovationDialog,
    MembershipRenovationDialog,
  } = useMembershipRenovation();

  return (
    <LazyLoad
      style={{ width: '100%' }}
      placeholder={<div style={{ height: 320 }} />}
    >
      <Loadable
        module={() =>
          import(
            /* webpackChunkName: "membership-renovation-banner" */
            './MembershipRenovationBanner'
          )
        }
        Loader={<Loader />}
        remainingDays={remainingDays}
        showRenovationDialog={showRenovationDialog}
        {...props}
      />
      {MembershipRenovationDialog}
    </LazyLoad>
  );
};

export default LazyMembershipRenovationBanner;
